import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { QuestionGroup } from 'src/app/shared/interfaces/process-config.interface';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ProcessesService } from '../../processes.service';

@Component({
    selector: 'app-manage-question-group',
    templateUrl: './manage-question-group.component.html',
    styleUrls: ['./manage-question-group.component.scss'],
})
export class ManageQuestionGroupComponent extends BaseClass implements OnInit {
    @Input() group: QuestionGroup;
    public form: UntypedFormGroup;
    public language: string;

    constructor(
        protected _toastController: ToastController,
        public _modalController: ModalController,
        protected _translationService: TranslationService,
        private _processesService: ProcessesService,
        private _formBuilder: UntypedFormBuilder) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.createFormGroup();
    }

    public dismiss(data?: any) {
        this._modalController.dismiss(data);
    }

    public changeSelectedLanguage(language: 'pt-BR' | 'en-US' | 'es-ES'): void {
        this.language = language;
    }

    public createFormGroup() {
        this.form = this._formBuilder.group({
            name: [this.group ? this.group.globalizationConfig['pt-BR'].title : '', Validators.required],
            nameEN: [this.group ? this.group.globalizationConfig['en-US'].title : '', Validators.required],
            nameES: [this.group ? this.group.globalizationConfig['es-ES'].title : '', Validators.required],
            showOnCalibration: [this.group ? this.group.showOnCalibration : false, Validators.required]
        });
    }

    public save() {
        if (this.form.valid) {
            const name = this.form.get('name').value;
            const nameEN = this.form.get('nameEN').value;
            const nameES = this.form.get('nameES').value;

            const showOnCalibration = this.form.get('showOnCalibration').value;
            if (this.group) {
                this.group.globalizationConfig['pt-BR'].title = name;
                this.group.globalizationConfig['en-US'].title = nameEN;
                this.group.globalizationConfig['es-ES'].title = nameES;
                this.group.showOnCalibration = showOnCalibration;
            }
            this.dismiss({
                name: name,
                showOnCalibration: showOnCalibration,
                globalizationConfig: {
                    'pt-BR': { title: name },
                    'en-US': { title: nameEN },
                    'es-ES': { title: nameES }
                }
            });
        }
    }
}
